<!-- Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. -->
<div role="group" [formGroup]="form" class="form">
	<mat-form-field class="hours" subscriptSizing="dynamic">
		<mat-label>{{ appStrings.HOURS }}</mat-label>
		<input
			matInput
			type="number"
			automationId="hourDuration"
			step="1"
			[min]="validationData['hours'].min"
			[max]="validationData['hours'].max"
			formControlName="hours"
			(blur)="onTouched()"
		/>
	</mat-form-field>

	<mat-form-field class="minutes" subscriptSizing="dynamic">
		<mat-label>{{ appStrings.MINUTES }}</mat-label>
		<input
			matInput
			type="number"
			step="1"
			automationId="minuteDuration"
			[min]="validationData['minutes'].min"
			[max]="validationData['minutes'].max"
			formControlName="minutes"
			(blur)="onTouched()"
		/>
	</mat-form-field>
</div>
